import type { Emitter } from "@core/events/emitter";

export interface ExplosionChangedEvent {
  readonly sceneId: string;
  readonly entityId: string;
  readonly rootSnapshotId: string;
  readonly oldFactor: number;
  readonly newFactor: number;
}

export interface IExplosionModifierModel {
  readonly onExplosionChanged: Emitter<ExplosionChangedEvent>;

  getExplosionFactor(sceneId: string, snapshotId: string): number;
  getRootSnapshotId(sceneId: string, snapshotId: string): string | null;
  canExplode(sceneId: string, snapshotId: string): boolean;

  /** Apply a local preview without writing storage. */
  setExplosionFactor(
    sceneId: string,
    snapshotId: string,
    factor: number,
  ): number | null;

  /** Apply and persist the root snapshot factor. */
  commitExplosionFactorAsync(
    sceneId: string,
    snapshotId: string,
    factor?: number,
  ): Promise<number | null>;

  dispose(): void;
}

export const EXPLOSION_MODIFIER_MODEL = Symbol.for(
  "Campfire.ExplosionModifierModel",
);
